import classNames from 'classnames/bind'

import styles from './NotFoundLayout.module.scss'
import { JsxChildrenProps } from '~/components'
import { Outlet } from 'react-router'
import { Suspense } from 'react'

const cx = classNames.bind(styles)

export const NotFoundLayout = ({ children }: JsxChildrenProps) => {
  return <div className={cx('container')}>{children}</div>
}
export const NotFoundLayoutOutlet = () => {
  return  <Suspense fallback={<div />}><div className={cx('container')}><Outlet/></div></Suspense>
}
